module OnlineDPR.Application.Client.Report.Helper

open Fable.Core
open OnlineDPR.Application.Shared

let handleError error =
    JS.console.log(error)

let rec private replaceCategory category oldItem newItem =
    match category = oldItem with
    | true ->   newItem
    | false ->  let replacedSubSubCategories = category.Subcategories
                                              |> List.map (fun subsubcategory -> replaceCategory subsubcategory oldItem newItem)
                { category with Subcategories = replacedSubSubCategories}

let updateCategoryInModel model oldCategory newCategory =
    {model with Data = { model.Data with Categories = model.Data.Categories
                                         |> List.map (fun iter -> replaceCategory iter oldCategory newCategory)}}